import { repo } from 'index';
import { useQuery } from '@tanstack/react-query';

export const useEnterpriseDriversRefuelingAmountInfo = () => {
  const { data, status, isLoading, refetch } = useQuery({
    queryKey: ['enterprise-drivers', 'refueling-amount'],
    queryFn: () => repo.fetchEnterpriseDriversRefuelingAmountInfo(),
  });

  const enterpriseDriversRefuelingAmountInfo = data?.data?.data ?? null;

  return {
    enterpriseDriversRefuelingAmountInfo,
    getEnterpriseDriversRefuelingAmountInfoStatus: status,
    isGetEnterpriseDriversRefuelingAmountInfoLoading: isLoading,
    refetchEnterpriseDriversRefuelingAmountInfo: refetch,
  };
};
